// Product catalog for Shay Cooks LLC. Demo data (no backend product CRUD needed for v1).
// Image URLs come from user-uploaded assets (hosted on Emergent CDN).
const oatmealScotchies =
  "https://customer-assets.emergentagent.com/job_37d29bdc-ed97-4853-8f03-b357dc0efe44/artifacts/26emals8_469040310_1045096817372857_5072478970718306661_n.jpg";
const whiteChocolateChip =
  "https://customer-assets.emergentagent.com/job_37d29bdc-ed97-4853-8f03-b357dc0efe44/artifacts/iysfg336_475024155_965724995540417_1408580852911085129_n.jpg";
const chocolateChipHero =
  "https://customer-assets.emergentagent.com/job_37d29bdc-ed97-4853-8f03-b357dc0efe44/artifacts/251avjdx_IMG_8097.jpeg";
const oreoBrownie =
  "https://customer-assets.emergentagent.com/job_37d29bdc-ed97-4853-8f03-b357dc0efe44/artifacts/676opkfz_IMG_8098.jpeg";
const chocolateChipParchment =
  "https://customer-assets.emergentagent.com/job_37d29bdc-ed97-4853-8f03-b357dc0efe44/artifacts/js7tkfsf_IMG_8099.jpeg";

export const IMAGES = {
  oatmealScotchies,
  whiteChocolateChip,
  chocolateChipHero,
  oreoBrownie,
  chocolateChipParchment,
  baker: "https://images.pexels.com/photos/30232344/pexels-photo-30232344.jpeg?auto=compress&cs=tinysrgb&w=900",
  packaging:
    "https://images.unsplash.com/photo-1626253934161-08cfea22e968?w=1200&q=75&auto=format",
  handsBreaking: "https://images.pexels.com/photos/4110528/pexels-photo-4110528.jpeg?auto=compress&cs=tinysrgb&w=1400",
  parchment: "https://images.pexels.com/photos/6996322/pexels-photo-6996322.jpeg?auto=compress&cs=tinysrgb&w=1400",
};


export const SITE_IMAGE_DEFAULTS = [
  { key: "home_hero", url: chocolateChipHero },
  { key: "home_cta", url: IMAGES.handsBreaking },
  { key: "menu_hero", url: IMAGES.parchment },
  { key: "about_baker", url: IMAGES.baker },
  { key: "about_story", url: IMAGES.handsBreaking },
  ...[
    chocolateChipHero,
    oreoBrownie,
    oatmealScotchies,
    whiteChocolateChip,
    chocolateChipParchment,
    oreoBrownie,
    chocolateChipHero,
    oatmealScotchies,
    whiteChocolateChip,
    chocolateChipParchment,
  ].map((url, index) => ({ key: `gallery_${index + 1}`, url })),
  ...[
    chocolateChipParchment,
    oreoBrownie,
    chocolateChipHero,
    oreoBrownie,
    whiteChocolateChip,
    oatmealScotchies,
  ].map((url, index) => ({ key: `review_${index + 1}`, url })),
];

export const getSiteImageDefault = (key) =>
  SITE_IMAGE_DEFAULTS.find((image) => image.key === key)?.url || "";

export const PRODUCTS = [
  {
    id: "cookie-choc-chip",
    name: "Chocolatey Chocolate Chip",
    category: "cookies",
    price: 3.5,
    dozen: 36,
    image: chocolateChipHero,
    description:
      "A timeless classic, loaded with rich semi-sweet chocolate chunks and finished with flaky sea salt.",
    tags: ["signature", "bestseller"],
  },
  {
    id: "cookie-heath",
    name: "Heath Bar Chocolate Chip",
    category: "cookies",
    price: 3.75,
    dozen: 40,
    image: chocolateChipParchment,
    description:
      "Brown butter dough studded with crunchy toffee bits and milk chocolate. Buttery, golden, irresistible.",
    tags: ["signature"],
  },
  {
    id: "cookie-pb-choc",
    name: "Peanut Butter Chocolate Chip",
    category: "cookies",
    price: 3.75,
    dozen: 40,
    image: whiteChocolateChip,
    description:
      "Soft peanut butter cookie hugged with dark and milk chocolate chips. Salty-sweet perfection.",
    tags: [],
  },
  {
    id: "cookie-oatmeal-raisin",
    name: "Oatmeal Raisin",
    category: "oatmeal",
    price: 3.25,
    dozen: 34,
    image: oatmealScotchies,
    description:
      "Old-school comfort. Hand-rolled oats, plump raisins, warm cinnamon — like a hug from home.",
    tags: [],
  },
  {
    id: "cookie-oatmeal-scotchies",
    name: "Oatmeal Scotchies",
    category: "oatmeal",
    price: 3.5,
    dozen: 36,
    image: oatmealScotchies,
    description:
      "Buttery oats meet pockets of melty butterscotch. Chewy edges, soft centers, deeply nostalgic.",
    tags: [],
  },
  {
    id: "brownie-plain",
    name: "Plain Brownie",
    category: "brownies",
    price: 4.5,
    dozen: 48,
    image: oreoBrownie,
    description:
      "Dense, fudgy and unapologetically chocolate. A crackled top, gooey middle, deep cocoa finish.",
    tags: [],
  },
  {
    id: "brownie-oreo",
    name: "Oreo Brownie",
    category: "brownies",
    price: 4.75,
    dozen: 52,
    image: oreoBrownie,
    description:
      "Our fudge brownie crowned with crushed Oreos baked into the crackly top. A texture lover's dream.",
    tags: ["signature", "bestseller"],
  },
  {
    id: "brownie-gf",
    name: "Gluten-Free Brownie",
    category: "brownies",
    price: 5.0,
    dozen: 54,
    image: oreoBrownie,
    description:
      "All the fudge, none of the wheat. Rich, chewy, and indistinguishable from the original.",
    tags: ["gluten-free"],
  },
  {
    id: "brownie-pb-chip",
    name: "Peanut Butter Chip Brownie",
    category: "brownies",
    price: 4.75,
    dozen: 52,
    image: oreoBrownie,
    description:
      "Fudge brownie loaded with creamy peanut butter chips. Decadent, nutty, deliciously rich.",
    tags: [],
  },
];

export const getProductById = (id) => PRODUCTS.find((p) => p.id === id);
export const getProductsByCategory = (cat) =>
  cat === "all" ? PRODUCTS : PRODUCTS.filter((p) => p.category === cat);

export const SIGNATURE_IDS = ["cookie-choc-chip", "cookie-heath", "brownie-oreo"];

export const REVIEWS = [
  {
    id: "r1",
    name: "Tasha M.",
    rating: 5,
    date: "2 weeks ago",
    title: "Best cookies in Orlando, hands down.",
    body: "I ordered a dozen of the Heath Bar cookies for my mom's birthday and she cried. Real tears. They're that good — buttery, crunchy in all the right places.",
    verified: true,
    photo: chocolateChipParchment,
  },
  {
    id: "r2",
    name: "Marcus W.",
    rating: 5,
    date: "1 month ago",
    title: "I dream about these Oreo brownies.",
    body: "I now think about these brownies daily. Fudgy, dense, and that crackly top with crushed Oreos? Unreal. Delivery was fast and the packaging was beautiful.",
    verified: true,
    photo: oreoBrownie,
  },
  {
    id: "r3",
    name: "Janelle P.",
    rating: 5,
    date: "3 weeks ago",
    title: "Tastes homemade in the best way.",
    body: "You can taste the love. These are NOT mass-produced — every cookie feels like it was just pulled out of someone's oven. The chocolate chip is my new comfort food.",
    verified: true,
    photo: chocolateChipHero,
  },
  {
    id: "r4",
    name: "Devon R.",
    rating: 5,
    date: "5 days ago",
    title: "Gluten-free that actually slaps.",
    body: "My wife has celiac and we've tried EVERY GF brownie out there. Shay's is the only one she finished without making a face. Honestly indistinguishable from regular.",
    verified: true,
    photo: oreoBrownie,
  },
  {
    id: "r5",
    name: "Brittany S.",
    rating: 5,
    date: "2 months ago",
    title: "Ordered for my office. Whole team obsessed.",
    body: "I got 4 dozen assorted for our Friday team lunch. By 2 PM the box was demolished. Three people DM'd me for the link. 10/10 will reorder.",
    verified: true,
    photo: whiteChocolateChip,
  },
  {
    id: "r6",
    name: "Kenya L.",
    rating: 5,
    date: "1 week ago",
    title: "Oatmeal Scotchies = childhood in a cookie.",
    body: "I haven't had cookies like this since my grandmother. The butterscotch is real, the oats are hearty, the centers are soft. Pure nostalgia.",
    verified: true,
    photo: oatmealScotchies,
  },
];

export const GALLERY_IMAGES = [
  chocolateChipHero,
  oreoBrownie,
  oatmealScotchies,
  whiteChocolateChip,
  chocolateChipParchment,
  oreoBrownie,
  chocolateChipHero,
  oatmealScotchies,
  whiteChocolateChip,
  chocolateChipParchment,
];
